module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-900-490.c7c6de1.woff2";